import React, { useState, useMemo, useRef } from "react";
import Swal from "sweetalert2";
import "./MemoryModal.css";
import {
  MoreHoriz,
  Plus,
  Sort,
  Trash,
  Check,
  XmarkCircle
} from "iconoir-react";

const MemoryModal = ({ memories, setMemories, onClose }) => {
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const [activeMenu, setActiveMenu] = useState(null);
  const [showInput, setShowInput] = useState(false);
  const [newMemory, setNewMemory] = useState("");
  const inputRef = useRef(null);

  /* ================= FILTER + SORT ================= */
  const filtered = useMemo(() => {
    let data = memories.filter(m =>
      m.text.toLowerCase().includes(search.toLowerCase())
    );

    data.sort((a, b) =>
      sortOrder === "newest" ? b.id - a.id : a.id - b.id
    );

    return data;
  }, [memories, search, sortOrder]);

  /* ================= HANDLERS ================= */
  const handleDelete = (id) => {
    setMemories(prev => prev.filter(m => m.id !== id));
  };

  const handleDeleteAll = async () => {
    const res = await Swal.fire({
      title: "Hapus semua memory?",
      text: "Tindakan ini tidak bisa dibatalkan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus"
    });

    if (res.isConfirmed) {
      setMemories([]);
    }
  };

  const handleAddMemory = () => {
    if (!newMemory.trim()) return;

    setMemories(prev => [
      ...prev,
      { id: Date.now(), text: newMemory }
    ]);

    setNewMemory("");
    setShowInput(false);
  };

  const toggleSortMenu = () => {
    setActiveMenu(prev => (prev === "sort" ? null : "sort"));
  };

  /* ================= UI ================= */
  return (
    <div className=" font-befa befa-memory-container">
      {/* Header */}
      <div className="befa-memory-header">
        <span className="befa-title">Memorisasi</span>
        <button className="befa-btn-close" onClick={onClose}>✕</button>
      </div>
      <div className="befa-memory-subtitle">
        <span>BeFa Insight menyimpan otomatis memori dari percakapan. Memori yang tersimpan tidak akan terhapus. Anda juga dapat mengimpor memori yang berasal dari Chatbot lain.</span>
      </div>
      <br></br>

      {/* Toolbar */}
        <div className="befa-memory-toolbar">
        {/* LEFT */}
        <div className="befa-toolbar-left">
            <button
            className="befa-btn-add"
            onClick={() => {
                setShowInput(true);
                setTimeout(() => inputRef.current?.focus(), 0);
            }}
            >
            <Plus /> Tambah Memori
            </button>

            <input
            className="befa-input-search small"
            placeholder="Cari Memory"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            />
        </div>

        {/* RIGHT */}
        <div className="befa-toolbar-actions">
            {/* SORT */}
            <div className="befa-more-wrapper">
            <button
                className={`befa-btn-sort ${activeMenu === "sort" ? "active" : ""}`}
                onClick={toggleSortMenu}
            >
                <Sort />
            </button>

            {activeMenu === "sort" && (
                <div className="befa-more-popup show">
                <button onClick={() => { setSortOrder("newest"); setActiveMenu(null); }}>
                    Newest First {sortOrder === "newest" && <Check />}
                </button>
                <button onClick={() => { setSortOrder("oldest"); setActiveMenu(null); }}>
                    Oldest First {sortOrder === "oldest" && <Check />}
                </button>
                </div>
            )}
            </div>

            {/* DELETE ALL */}
            <div className="befa-tooltip-wrapper">
            <button
                className="befa-btn-delete-all"
                onClick={handleDeleteAll}
            >
                <Trash />
            </button>
            <span className="befa-tooltip">Delete All</span>
            </div>
        </div>
        </div>

        {showInput && (
          <input
            ref={inputRef}
            className="befa-input-add"
            placeholder="Tulis memory lalu tekan Enter..."
            value={newMemory}
            onChange={(e) => setNewMemory(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAddMemory()}
          />
        )}

      {/* List */}
      <div className="befa-memory-list">
        {filtered.length === 0 && (
          <div className="befa-empty">Memory tidak ditemukan</div>
        )}

        {filtered.map(m => (
          <div key={m.id} className="befa-memory-item">
            <span>{m.text}</span>

            <button
              className="befa-btn-item-delete"
              onClick={() => handleDelete(m.id)}
            >
              <XmarkCircle />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MemoryModal;